// extracted by css-extract-rspack-plugin
export default {"archiveButton":"jU3BS"};